// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BuildingPriceTable_tableWrapper__XbInK {
  width: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.BuildingPriceTable_buttonsRow__FVAcr{
    display: flex;
    align-items: center;
    gap: 30px;
    margin-top: 40px;
}
.BuildingPriceTable_buttonsRow__FVAcr h2{
    font-size: var(--font-size-4xl);
    margin: 0;
    color: #fff;
}
.BuildingPriceTable_buttons__-cBz5{
    display: flex;
    align-items: center;
    gap: 15px;
}
.BuildingPriceTable_button__hVYjj{
    position: relative;
    padding: 8px 16px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: var(--font-size-3xl);
    color: var(--color-accent-dark);
    transition: color 0.3s ease;
}
.BuildingPriceTable_button__hVYjj::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: var(--color-accent-dark);
    transition: width 0.3s ease;
}
.BuildingPriceTable_button__hVYjj:hover {
    color: var(--color-accent-light);
}
.BuildingPriceTable_button__hVYjj:hover::after {
    width: 100%;
}
.BuildingPriceTable_buttonActive__r8MOB {
    color: #fff;
    /* font-weight: bold; */
}
.BuildingPriceTable_buttonActive__r8MOB::after {
    width: 100%;
}
.BuildingPriceTable_tableTitle__q\\+kpU {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.BuildingPriceTable_warning__BGwo3 {
  color: var(--color-primary);
  font-size: 0.9rem;
  margin: 10px 0;
}

.BuildingPriceTable_tableContainer__4cnf0 {
  max-width: 1110px;
  width: 100%;
  overflow-x: auto;
  border-radius: var(--border-radius-lg);
  scrollbar-width: thin;
  scrollbar-color: var(--color-accent-light) #fff;
}

.BuildingPriceTable_tableContainer__4cnf0::-webkit-scrollbar {
  height: 8px;
}

.BuildingPriceTable_tableContainer__4cnf0::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 4px;
}

.BuildingPriceTable_tableContainer__4cnf0::-webkit-scrollbar-thumb {
  background-color: var(--color-accent-light);
  border-radius: 4px;
}

.BuildingPriceTable_priceTable__pLzYP {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.BuildingPriceTable_headerCell__n-hPk {
  background-color: var(--color-accent-light);
  padding: 12px 8px;
  text-align: center;
  font-weight: bold;
  font-size: var(--font-size-lg);
  color: #fff;
  border: 1px solid var(--color-background);
  vertical-align: middle;
}

.BuildingPriceTable_nameCell__XQDkV,
.BuildingPriceTable_priceCell__Ny7zj {
  padding: 12px 8px;
  border: 1px solid var(--color-background);
  font-size: var(--font-size-md);
  color: var(--color-background);
}
.BuildingPriceTable_nameCell__XQDkV{
  font-weight: bold;
  text-align: left;
}
.BuildingPriceTable_tableRow__AQeu\\+:nth-child(even) {
  background-color: var(--color-accent-super-light);
}

.BuildingPriceTable_tableRow__AQeu\\+:hover {
  background-color: var(--color-accent-super-light-pressed);
}

.BuildingPriceTable_totalRow__ws0Wk {
  background: var(--color-accent-light);
  font-weight: bold;
}

.BuildingPriceTable_pricePerMeterRow__wRjTP,
.BuildingPriceTable_areaRow__Pk5ih{
  background: var(--color-accent-light);
} 
.BuildingPriceTable_pricePerMeterRow__wRjTP td, .BuildingPriceTable_areaRow__Pk5ih td, .BuildingPriceTable_totalRow__ws0Wk td{
  color: #fff;
}
.BuildingPriceTable_pricePerMeterRow__wRjTP .BuildingPriceTable_nameCell__XQDkV, .BuildingPriceTable_areaRow__Pk5ih .BuildingPriceTable_nameCell__XQDkV, .BuildingPriceTable_totalRow__ws0Wk .BuildingPriceTable_nameCell__XQDkV{
    text-align: right;
}

.BuildingPriceTable_subHeaderCell__xsV1m {
  background-color: var(--color-accent-light);
  padding: 8px 6px;
  text-align: center;
  font-size: var(--font-size-md);
  color: #fff;
  border: 1px solid var(--color-background);
  font-weight: normal;
}

.BuildingPriceTable_nameCellWrapper__9jAqD {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.BuildingPriceTable_helpIcon__uvyi0 {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  color: var(--color-background);

  border: 1px solid var(--color-background);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: help;
  position: relative;
}

.BuildingPriceTable_tooltip__8zlGF {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  width: max-content;
  max-width: 250px;
  margin-left: 8px;
  z-index: 1000;
  
  /* Начальное состояние */
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.BuildingPriceTable_helpIcon__uvyi0:hover .BuildingPriceTable_tooltip__8zlGF {
  /* Состояние при наведении */
  opacity: 1;
  visibility: visible;
}
.BuildingPriceTable_buttonRow__F9T\\+C{
  display: flex;
  align-items: center;
  gap: 15px;
  max-width: 500px;
  flex-direction: column;
}


/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .BuildingPriceTable_buttonsRow__FVAcr{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  .BuildingPriceTable_buttonsRow__FVAcr h2{
    font-size: var(--font-size-2xl);
  }
  .BuildingPriceTable_buttonsRow__FVAcr .BuildingPriceTable_button__hVYjj{
    font-size: var(--font-size-xl);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Tables/BuildingPriceTable/BuildingPriceTable.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,+BAA+B;IAC/B,SAAS;IACT,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,+BAA+B;IAC/B,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,0CAA0C;IAC1C,2BAA2B;AAC/B;AACA;IACI,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;EACX,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iDAAiD;AACnD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;;EAEE,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;AACA;IACI,iBAAiB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;;EAE9B,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;;EAEb,wBAAwB;EACxB,UAAU;EACV,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;;AAGA,yCAAyC;AACzC;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".tableWrapper {\n  width: 100%;\n  margin: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.buttonsRow{\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    margin-top: 40px;\n}\n.buttonsRow h2{\n    font-size: var(--font-size-4xl);\n    margin: 0;\n    color: #fff;\n}\n.buttons{\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n.button{\n    position: relative;\n    padding: 8px 16px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: var(--font-size-3xl);\n    color: var(--color-accent-dark);\n    transition: color 0.3s ease;\n}\n.button::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 0;\n    height: 2px;\n    background-color: var(--color-accent-dark);\n    transition: width 0.3s ease;\n}\n.button:hover {\n    color: var(--color-accent-light);\n}\n.button:hover::after {\n    width: 100%;\n}\n.buttonActive {\n    color: #fff;\n    /* font-weight: bold; */\n}\n.buttonActive::after {\n    width: 100%;\n}\n.tableTitle {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.warning {\n  color: var(--color-primary);\n  font-size: 0.9rem;\n  margin: 10px 0;\n}\n\n.tableContainer {\n  max-width: 1110px;\n  width: 100%;\n  overflow-x: auto;\n  border-radius: var(--border-radius-lg);\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-accent-light) #fff;\n}\n\n.tableContainer::-webkit-scrollbar {\n  height: 8px;\n}\n\n.tableContainer::-webkit-scrollbar-track {\n  background: #fff;\n  border-radius: 4px;\n}\n\n.tableContainer::-webkit-scrollbar-thumb {\n  background-color: var(--color-accent-light);\n  border-radius: 4px;\n}\n\n.priceTable {\n  width: 100%;\n  min-width: 800px;\n  border-collapse: collapse;\n  background-color: #fff;\n  border-radius: var(--border-radius-lg);\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.headerCell {\n  background-color: var(--color-accent-light);\n  padding: 12px 8px;\n  text-align: center;\n  font-weight: bold;\n  font-size: var(--font-size-lg);\n  color: #fff;\n  border: 1px solid var(--color-background);\n  vertical-align: middle;\n}\n\n.nameCell,\n.priceCell {\n  padding: 12px 8px;\n  border: 1px solid var(--color-background);\n  font-size: var(--font-size-md);\n  color: var(--color-background);\n}\n.nameCell{\n  font-weight: bold;\n  text-align: left;\n}\n.tableRow:nth-child(even) {\n  background-color: var(--color-accent-super-light);\n}\n\n.tableRow:hover {\n  background-color: var(--color-accent-super-light-pressed);\n}\n\n.totalRow {\n  background: var(--color-accent-light);\n  font-weight: bold;\n}\n\n.pricePerMeterRow,\n.areaRow{\n  background: var(--color-accent-light);\n} \n.pricePerMeterRow td, .areaRow td, .totalRow td{\n  color: #fff;\n}\n.pricePerMeterRow .nameCell, .areaRow .nameCell, .totalRow .nameCell{\n    text-align: right;\n}\n\n.subHeaderCell {\n  background-color: var(--color-accent-light);\n  padding: 8px 6px;\n  text-align: center;\n  font-size: var(--font-size-md);\n  color: #fff;\n  border: 1px solid var(--color-background);\n  font-weight: normal;\n}\n\n.nameCellWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.helpIcon {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  color: var(--color-background);\n\n  border: 1px solid var(--color-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  cursor: help;\n  position: relative;\n}\n\n.tooltip {\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  width: max-content;\n  max-width: 250px;\n  margin-left: 8px;\n  z-index: 1000;\n  \n  /* Начальное состояние */\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n.helpIcon:hover .tooltip {\n  /* Состояние при наведении */\n  opacity: 1;\n  visibility: visible;\n}\n.buttonRow{\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  max-width: 500px;\n  flex-direction: column;\n}\n\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .buttonsRow{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n  }\n  .buttonsRow h2{\n    font-size: var(--font-size-2xl);\n  }\n  .buttonsRow .button{\n    font-size: var(--font-size-xl);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `BuildingPriceTable_tableWrapper__XbInK`,
	"buttonsRow": `BuildingPriceTable_buttonsRow__FVAcr`,
	"buttons": `BuildingPriceTable_buttons__-cBz5`,
	"button": `BuildingPriceTable_button__hVYjj`,
	"buttonActive": `BuildingPriceTable_buttonActive__r8MOB`,
	"tableTitle": `BuildingPriceTable_tableTitle__q+kpU`,
	"warning": `BuildingPriceTable_warning__BGwo3`,
	"tableContainer": `BuildingPriceTable_tableContainer__4cnf0`,
	"priceTable": `BuildingPriceTable_priceTable__pLzYP`,
	"headerCell": `BuildingPriceTable_headerCell__n-hPk`,
	"nameCell": `BuildingPriceTable_nameCell__XQDkV`,
	"priceCell": `BuildingPriceTable_priceCell__Ny7zj`,
	"tableRow": `BuildingPriceTable_tableRow__AQeu+`,
	"totalRow": `BuildingPriceTable_totalRow__ws0Wk`,
	"pricePerMeterRow": `BuildingPriceTable_pricePerMeterRow__wRjTP`,
	"areaRow": `BuildingPriceTable_areaRow__Pk5ih`,
	"subHeaderCell": `BuildingPriceTable_subHeaderCell__xsV1m`,
	"nameCellWrapper": `BuildingPriceTable_nameCellWrapper__9jAqD`,
	"helpIcon": `BuildingPriceTable_helpIcon__uvyi0`,
	"tooltip": `BuildingPriceTable_tooltip__8zlGF`,
	"buttonRow": `BuildingPriceTable_buttonRow__F9T+C`
};
export default ___CSS_LOADER_EXPORT___;
